module.exports = __webpack_public_path__ + "3360ed8014465c63ad561e5ad245b7de.dcm";